import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { invoiceListDemoData } from '../../../../../data/invoiceListDemoData';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { handleLoadInvoiceListData } from '../InvoiceOperation';

const BillingInvoiceListContext = createContext();
export const useBillingInvoice = () => useContext(BillingInvoiceListContext);

function InvoiceListProvider({ children }) {
    const [reloadKey, setReloadKey] = useState(0);
    const [invoiceData, setInvoiceData] = useState(invoiceListDemoData);
    const [params, setParams] = useState({});

    const { setMessage } = useTemplate();
    // -- Load invoice list data
    useEffect(() => {
        setInvoiceData({ invoices: invoiceListDemoData, pagination: {} });
        if (Object.keys(params).length > 0) {
            handleLoadInvoiceListData(params)
                .then(({ data }) => {
                    setInvoiceData(data);
                })
                .catch((err) => {
                    setInvoiceData({ invoices: [], pagination: {} });
                    setMessage({ type: 'error', text: err.toString(0) });
                });
        }
    }, [setMessage, reloadKey, params]);

    const value = useMemo(() => {
        // --Handle Reload
        const handleReload = () => {
            setReloadKey((d) => d + 1);
        };

        return {
            // Data filter data
            setParams,

            // Reload Key
            reloadKey,
            setReloadKey,
            // -- customer list
            invoiceData,
            setInvoiceData,

            // All Handler
            handleReload
        };
    }, [invoiceData, reloadKey]);

    return (
        <BillingInvoiceListContext.Provider value={value}>
            {children}
        </BillingInvoiceListContext.Provider>
    );
}

export default InvoiceListProvider;
